import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faAnalytics } from '@fortawesome/pro-regular-svg-icons/faAnalytics';
import { faPencilRuler } from '@fortawesome/pro-regular-svg-icons/faPencilRuler';
import { faChartNetwork } from '@fortawesome/pro-regular-svg-icons/faChartNetwork';
import { faPuzzlePiece } from '@fortawesome/pro-regular-svg-icons/faPuzzlePiece';
import { faDatabase } from '@fortawesome/pro-regular-svg-icons/faDatabase';
import { faThList } from '@fortawesome/pro-regular-svg-icons/faThList';
import { faLink } from '@fortawesome/pro-regular-svg-icons/faLink';
import { faReact } from '@fortawesome/free-brands-svg-icons/faReact';
import { faHdd } from '@fortawesome/pro-regular-svg-icons/faHdd';
import { faSave } from '@fortawesome/pro-regular-svg-icons/faSave';
import { faImages } from '@fortawesome/pro-regular-svg-icons/faImages';
import { faUserFriends } from '@fortawesome/pro-regular-svg-icons/faUserFriends';
import { faUser } from '@fortawesome/pro-regular-svg-icons/faUser';
import { faUsers } from '@fortawesome/pro-regular-svg-icons/faUsers';
import { faBell } from '@fortawesome/pro-regular-svg-icons/faBell';
import { faBellPlus } from '@fortawesome/pro-regular-svg-icons/faBellPlus';
import { faGrid2Plus } from '@fortawesome/pro-regular-svg-icons/faGrid2Plus';
import { faRocketLaunch } from '@fortawesome/pro-regular-svg-icons/faRocketLaunch';
import { faTools } from '@fortawesome/pro-regular-svg-icons/faTools';
import { faCogs } from '@fortawesome/pro-regular-svg-icons/faCogs';
import { faArrowCircleUp } from '@fortawesome/pro-regular-svg-icons/faArrowCircleUp';
import { faCubes } from '@fortawesome/pro-regular-svg-icons/faCubes';
import { faUserLock } from '@fortawesome/pro-regular-svg-icons/faUserLock';
import { faUserShield } from '@fortawesome/pro-regular-svg-icons/faUserShield';
import { faLock } from '@fortawesome/pro-regular-svg-icons/faLock';
import { faNetworkWired } from '@fortawesome/pro-regular-svg-icons/faNetworkWired';
import { faLanguage } from '@fortawesome/pro-regular-svg-icons/faLanguage';
import { faPaintbrush } from '@fortawesome/pro-regular-svg-icons/faPaintbrush';
import { faWrench } from '@fortawesome/pro-regular-svg-icons/faWrench';
import { faListAlt } from '@fortawesome/pro-regular-svg-icons/faListAlt';
import { faImage } from '@fortawesome/pro-regular-svg-icons/faImage';
import { faFile } from '@fortawesome/pro-regular-svg-icons/faFile';
import { faIcons } from '@fortawesome/pro-regular-svg-icons/faIcons';
import { faSlidersV } from '@fortawesome/pro-regular-svg-icons/faSlidersV';
import { AppSideNavigationSubMenuItemIcon, UpdateAvailabelWrapper, UpdateAvailabelMark, } from './styles';
import AppBuilderMenuItem from '@project/components/AppBuilderMenuItem';
var AppBuilderMenu = function (appId, orgId, isUpToDate) {
    var result = [
        {
            id: 1,
            header: 'Overview',
            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/overview"),
            activationPathMatch: '/organizations/:organizationId/apps/:appId/overview',
            icon: _jsx(AppBuilderMenuItem, { title: "Overview", iconName: faAnalytics }),
        },
        {
            id: 2,
            header: 'View Builder',
            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/views"),
            activationPathMatch: '/organizations/:organizationId/apps/:appId/views/*',
            icon: _jsx(AppBuilderMenuItem, { title: "Design", iconName: faPencilRuler }),
        },
        {
            id: 3,
            header: 'Structure Builder',
            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/structure"),
            activationPathMatch: '/organizations/:organizationId/apps/:appId/structure',
            icon: _jsx(AppBuilderMenuItem, { title: "Structure", iconName: faChartNetwork }),
        },
        {
            id: 4,
            header: 'Logic Builder',
            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/logic"),
            activationPathMatch: '/organizations/:organizationId/apps/:appId/logic/*',
            icon: _jsx(AppBuilderMenuItem, { title: "Logic", iconName: faPuzzlePiece }),
        },
        {
            id: 5,
            header: 'Data',
            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/datasets"),
            activationPathMatch: '/organizations/:organizationId/apps/:appId/datasets/*',
            icon: _jsx(AppBuilderMenuItem, { title: "Data", iconName: faDatabase }),
            children: [
                {
                    title: 'Data',
                    data: [
                        {
                            label: 'Datasets',
                            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/datasets"),
                            activationPathMatch: '/organizations/:organizationId/apps/:appId/datasets/*',
                            icon: _jsx(AppSideNavigationSubMenuItemIcon, { icon: faThList }),
                            target: "app:".concat(appId, ":datasets"),
                        },
                        {
                            label: 'Integrations',
                            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/integrations"),
                            activationPathMatch: '/organizations/:organizationId/apps/:appId/integrations/*',
                            icon: _jsx(AppSideNavigationSubMenuItemIcon, { icon: faLink }),
                            target: "app:".concat(appId, ":integrations"),
                        },
                        {
                            label: 'State',
                            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/state"),
                            activationPathMatch: '/organizations/:organizationId/apps/:appId/state/*',
                            icon: _jsx(AppSideNavigationSubMenuItemIcon, { icon: faReact }),
                            target: "app:".concat(appId, ":states"),
                        },
                        {
                            label: 'Storage',
                            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/storage"),
                            activationPathMatch: '/organizations/:organizationId/apps/:appId/storage/*',
                            icon: _jsx(AppSideNavigationSubMenuItemIcon, { icon: faHdd }),
                            target: "app:".concat(appId, ":storage"),
                        },
                        {
                            label: 'Variables',
                            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/variables"),
                            activationPathMatch: '/organizations/:organizationId/apps/:appId/variables/*',
                            icon: _jsx(AppSideNavigationSubMenuItemIcon, { icon: faSave }),
                            target: "app:".concat(appId, ":variables"),
                        },
                        {
                            label: 'Environment',
                            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/environments"),
                            activationPathMatch: '/organizations/:organizationId/apps/:appId/environments/*',
                            icon: _jsx(AppSideNavigationSubMenuItemIcon, { icon: faSlidersV }),
                            target: "app:".concat(appId, ":environments"),
                        },
                    ],
                },
            ],
        },
        {
            id: 6,
            header: 'Assets',
            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/media/all"),
            activationPathMatch: '/organizations/:organizationId/apps/:appId/media/*',
            icon: _jsx(AppBuilderMenuItem, { title: "Assets", iconName: faImages }),
            target: "app:".concat(appId),
            children: [
                {
                    title: 'Assets',
                    data: [
                        {
                            label: 'All',
                            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/media/all"),
                            activationPathMatch: '/organizations/:organizationId/apps/:appId/media/all',
                            icon: _jsx(AppSideNavigationSubMenuItemIcon, { icon: faListAlt }),
                        },
                        {
                            label: 'Images',
                            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/media/images"),
                            activationPathMatch: '/organizations/:organizationId/apps/:appId/media/images',
                            icon: _jsx(AppSideNavigationSubMenuItemIcon, { icon: faImage }),
                        },
                        {
                            label: 'Files',
                            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/media/files"),
                            activationPathMatch: '/organizations/:organizationId/apps/:appId/media/files',
                            icon: _jsx(AppSideNavigationSubMenuItemIcon, { icon: faFile }),
                        },
                        {
                            label: 'Icons',
                            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/media/icons"),
                            activationPathMatch: '/organizations/:organizationId/apps/:appId/media/icons',
                            icon: _jsx(AppSideNavigationSubMenuItemIcon, { icon: faIcons }),
                        },
                    ],
                },
            ],
        },
        {
            id: 7,
            header: 'Users',
            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/users"),
            activationPathMatch: '/organizations/:organizationId/apps/:appId/users/*',
            icon: _jsx(AppBuilderMenuItem, { title: "Users", iconName: faUsers }),
            children: [
                {
                    title: 'Users',
                    data: [
                        {
                            label: 'Users',
                            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/users"),
                            activationPathMatch: '/organizations/:organizationId/apps/:appId/users/*',
                            icon: _jsx(AppSideNavigationSubMenuItemIcon, { icon: faUser }),
                        },
                        {
                            label: ' User Groups',
                            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/groups"),
                            activationPathMatch: '/organizations/:organizationId/apps/:appId/groups/*',
                            icon: _jsx(AppSideNavigationSubMenuItemIcon, { icon: faUserFriends }),
                        },
                        {
                            label: 'Shared Users Management',
                            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/shareusers"),
                            activationPathMatch: '/organizations/:organizationId/apps/:appId/shareusers/*',
                            icon: _jsx(AppSideNavigationSubMenuItemIcon, { icon: faGrid2Plus }),
                        },
                    ],
                },
            ],
        },
        {
            id: 8,
            header: 'Notify',
            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/push/notifications"),
            activationPathMatch: '/organizations/:organizationId/apps/:appId/push/*',
            icon: _jsx(AppBuilderMenuItem, { title: "Notify", iconName: faBell }),
            target: "app:".concat(appId, ":push"),
            children: [
                {
                    title: 'Notify',
                    data: [
                        {
                            label: 'Push Notifications',
                            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/push/notifications"),
                            activationPathMatch: '/organizations/:organizationId/apps/:appId/push/notifications/*',
                            icon: _jsx(AppSideNavigationSubMenuItemIcon, { icon: faBell }),
                            target: "app:".concat(appId, ":push"),
                        },
                        {
                            label: 'Push Templates',
                            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/push/templates"),
                            activationPathMatch: '/organizations/:organizationId/apps/:appId/push/templates/*',
                            icon: _jsx(AppSideNavigationSubMenuItemIcon, { icon: faBellPlus }),
                        },
                        {
                            label: 'Push Multi-Apps',
                            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/push/senderapps"),
                            activationPathMatch: '/organizations/:organizationId/apps/:appId/push/senderapps/*',
                            icon: _jsx(AppSideNavigationSubMenuItemIcon, { icon: faGrid2Plus }),
                            target: "app:".concat(appId, ":push"),
                        },
                    ],
                },
            ],
        },
        {
            id: 9,
            header: 'Publish',
            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/versions"),
            activationPathMatch: [
                '/organizations/:organizationId/apps/:appId/configuration/*',
                '/organizations/:organizationId/apps/:appId/versions/*',
                '/organizations/:organizationId/apps/:appId/distribution/*',
            ],
            icon: _jsx(AppBuilderMenuItem, { title: "Publish", iconName: faRocketLaunch }),
            target: "app:".concat(appId, ":publishing"),
            children: [
                {
                    title: 'Publish',
                    data: [
                        {
                            label: 'Versions',
                            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/versions"),
                            activationPathMatch: '/organizations/:organizationId/apps/:appId/versions',
                            icon: _jsx(AppSideNavigationSubMenuItemIcon, { icon: faCubes }),
                            target: "app:".concat(appId, ":publishing"),
                        },
                        {
                            label: 'Configuration',
                            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/configuration"),
                            activationPathMatch: '/organizations/:organizationId/apps/:appId/configuration',
                            icon: _jsx(AppSideNavigationSubMenuItemIcon, { icon: faCogs }),
                            target: "app:".concat(appId, ":publishing"),
                        },
                        {
                            label: 'Distribution',
                            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/distribution"),
                            activationPathMatch: '/organizations/:organizationId/apps/:appId/distribution',
                            icon: _jsx(AppSideNavigationSubMenuItemIcon, { icon: faArrowCircleUp }),
                            target: "app:".concat(appId, ":publishing"),
                        },
                    ],
                },
            ],
        },
        {
            id: 10,
            header: 'Settings',
            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/settings"),
            activationPathMatch: [
                '/organizations/:organizationId/apps/:appId/settings/*',
                '/organizations/:organizationId/apps/:appId/styles/*',
                '/organizations/:organizationId/apps/:appId/distribution/*',
                '/organizations/:organizationId/apps/:appId/languages/*',
                '/organizations/:organizationId/apps/:appId/translations/*',
                '/organizations/:organizationId/apps/:appId/template/*',
                '/organizations/:organizationId/apps/:appId/keys/*',
                '/organizations/:organizationId/apps/:appId/access/targets/*',
                '/organizations/:organizationId/apps/:appId/admins/*',
                '/organizations/:organizationId/apps/:appId/permissions/*',
                '/organizations/:organizationId/apps/:appId/roles/*',
            ],
            icon: isUpToDate ? (_jsx(AppBuilderMenuItem, { title: "Settings", iconName: faTools })) : (_jsxs(UpdateAvailabelWrapper, { children: [_jsx(UpdateAvailabelMark, {}), _jsx(AppBuilderMenuItem, { title: "Settings", iconName: faTools })] })),
            children: [
                {
                    title: 'App Settings',
                    data: [
                        {
                            label: 'General',
                            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/settings"),
                            activationPathMatch: '/organizations/:organizationId/apps/:appId/settings/*',
                            icon: _jsx(AppSideNavigationSubMenuItemIcon, { icon: faWrench }),
                        },
                        {
                            label: 'Styles',
                            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/styles"),
                            activationPathMatch: '/organizations/:organizationId/apps/:appId/styles/*',
                            icon: _jsx(AppSideNavigationSubMenuItemIcon, { icon: faPaintbrush }),
                            target: "app:".concat(appId, ":styles"),
                        },
                        {
                            label: 'Localization',
                            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/translations"),
                            activationPathMatch: [
                                '/organizations/:organizationId/apps/:appId/languages/*',
                                '/organizations/:organizationId/apps/:appId/translations/*',
                            ],
                            icon: _jsx(AppSideNavigationSubMenuItemIcon, { icon: faLanguage }),
                            target: "app:".concat(appId, ":translations"),
                        },
                        {
                            label: 'template',
                            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/template"),
                            activationPathMatch: '/organizations/:organizationId/apps/:appId/template/*',
                            icon: _jsx(AppSideNavigationSubMenuItemIcon, { icon: faLanguage }),
                            target: "app:".concat(appId, ":template"),
                        },
                    ],
                },
                {
                    title: 'Access Control',
                    data: [
                        {
                            label: 'API',
                            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/keys"),
                            activationPathMatch: '/organizations/:organizationId/apps/:appId/keys/*',
                            icon: _jsx(AppSideNavigationSubMenuItemIcon, { icon: faNetworkWired }),
                        },
                        {
                            label: 'Permission Items',
                            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/access/targets"),
                            activationPathMatch: '/organizations/:organizationId/apps/:appId/access/targets/*',
                            icon: _jsx(AppSideNavigationSubMenuItemIcon, { icon: faLock }),
                        },
                        {
                            label: 'Admins',
                            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/admins"),
                            activationPathMatch: [
                                '/organizations/:organizationId/apps/:appId/admins/*',
                                '/organizations/:organizationId/apps/:appId/permissions/*',
                            ],
                            icon: _jsx(AppSideNavigationSubMenuItemIcon, { icon: faUserShield }),
                            target: "app:".concat(appId, ":appadmin"),
                        },
                        {
                            label: 'Roles',
                            slug: "/organizations/".concat(orgId, "/apps/").concat(appId, "/roles"),
                            activationPathMatch: '/organizations/:organizationId/apps/:appId/roles/*',
                            icon: _jsx(AppSideNavigationSubMenuItemIcon, { icon: faUserLock }),
                            target: "app:".concat(appId, ":appadmin"),
                        },
                    ],
                },
            ],
        },
    ];
    return result;
};
export default AppBuilderMenu;
